import { Injectable } from "@angular/core";
import { NgbDateParserFormatter, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import moment from 'moment';

@Injectable()
export class NgbDateParserFormatterES extends NgbDateParserFormatter {
    parse(value: string): NgbDateStruct {
        let date = moment(value, "DD/MM/YYYY");
        if (date.isValid()) return { day: date.day(), month: date.month(), year: date.year() };
        else return null;
    }

    format(date: NgbDateStruct): string {
        let momentDate = moment(date);
        if (momentDate.isValid()) return momentDate.format("DD/MM/YYYY");
        else return null;
    }
}
